import axios from 'axios';

const BASE = process.env.REACT_APP_API_URL;
const ax = axios.create({ baseURL: BASE });
ax.interceptors.request.use(c => {
  const t = localStorage.getItem('accessToken') || localStorage.getItem('token') || sessionStorage.getItem('accessToken');
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});
ax.interceptors.response.use(r => r, err => {
  if (err.response?.status === 401 && !window.location.pathname.startsWith('/api/shr/share/')) window.location.href = '/login';
  return Promise.reject(err);
});

export const shrHealth = () => ax.get('/shr/health');
export const shrDashboard = () => ax.get('/shr/dashboard');
export const shrAudit = (patientId?: string) => ax.get('/shr/audit', { params: { patientId } });
export const shrGetConsent = (patientId: string, encounterId?: string) =>
  ax.get(`/shr/consent/patient/${patientId}`, { params: { encounterId } });
export const shrRequestConsent = (d: any) => ax.post('/shr/consent/request', d);
export const shrVerifyOtp = (id: string, otp: string) => ax.post(`/shr/consent/${id}/verify`, { otp });
export const shrConsentStatus = (id: string) => ax.get(`/shr/consent/${id}/status`);
export const shrResendOtp = (id: string) => ax.post(`/shr/consent/${id}/resend`);
export const shrRefreshVisit = (id: string) => ax.post(`/shr/visit/${id}/refresh`);
export const shrCloseVisit = (id: string) => ax.post(`/shr/visit/${id}/close`);
export const shrOpenVisits = (patientId: string) => ax.get('/shr/open-visits', { params: { patientId } });
export const shrPatientRecords = (patientId: string, resources: string, pageToken?: string) =>
  ax.get('/shr/patient-records', { params: { patientId, resources, pageToken } });
export const shrObservations = (patientId: string, pageToken?: string) =>
  ax.get('/shr/observations', { params: { patientId, pageToken } });
export const shrReferrals = (patientId: string, pageToken?: string) =>
  ax.get('/shr/referrals', { params: { patientId, pageToken } });
export const shrPreviewBundle = (d: any) => ax.post('/shr/sync/preview', d);
export const shrPublishShare = (d: any) => ax.post('/shr/share/publish', d);
/** Admin only — Bearer for GET /api/v1/clinical/fhir/... (up to 7 days). */
export const shrIssueDhaToken = (d?: { ttlDays?: number }) => ax.post('/shr/dha-token', d || { ttlDays: 7 });
export const shrSyncEncounter = (d: any) => ax.post('/shr/sync/encounter', d);
export const shrRetrySync = (id: string) => ax.post(`/shr/sync/${id}/retry`);
export const shrSyncStatus = (id: string) => ax.get(`/shr/sync/${id}/status`);
